<template>
  
  <transition name="router-anim">
    <div class="kits">
      <DescriptionModal class="description-modal" :description="`This section allows you to add federal holidays, which are used in calculations like average shipping time, activation time, and other related metrics.`" />
      <div class="kits-title">
        <div class="title name">
         NAME
        </div>
        <div class="title year">
         Year
        </div>
        <div class="title date" @click="sortedBy">
         DATE
          <img
            src="../../images/dashboard/up.png"
            alt="#"
            v-if="sortedByState === 'desc'"
          />
          <img
            class="down"
            src="../../images/dashboard/up.png"
            alt="#"
            v-else
          />
        </div>
      </div>
      <div v-if="holidays.length > 0">
        <div class="kits-item" v-for="item in holidays" :key="item.id">
          <div class="kit-desc name">
            <span>{{ item.name }}</span>
          </div>
          <div class="kit-desc year">
            <span>{{ item.year }}</span>
          </div>
          <div class="kit-desc date">
            {{ item.holiday_at }}
          </div>
          <div
            title="Delete"
            class="remove-kit-btn"
            v-if="role === 'superadmin'"
            @click="remove(item.id)"
          ></div>
        </div>
      </div>
      <div v-else class="kits-item">
        <div class="kit-desc nodata">
          No Data Retrieved.
        </div>
      </div>
      <div class="pogination">
        <Paginate
          v-if="count_page > 1"
          :page-count="count_page"
          :page-class="'pogination-item'"
          :click-handler="changePage"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pogination-wrap'"
        ></Paginate>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import Paginate from "vuejs-paginate";
import Remove from "../../images/dashboard/Remove";

export default {
  name: "FederalHolidays",
  data() {
    return {
      holidays: [],
      count_page: 1,
      sortedByState: "desc",
    };
  },
  components: {
    Paginate,
    Remove
  },
  methods: {
    changePage(item) {
      this.setPginationPage(item).then(res => {
        this.getFederalHolidays();
      });
    },
    ...mapActions([
      "getFederalHolidays",
      "setSortedBy",
      "setPginationPage"
    ]),
    remove(id) {
      this.$emit("confirmDelHoliday", { show: true, id });
    },
    sortedBy() {
      if (this.sortedByState === "desc") {
        this.sortedByState = "asc";
      } else {
        this.sortedByState = "desc";
      }
      this.setSortedBy(this.sortedByState);
      this.getFederalHolidays();
    },
    date(localDate) {
      if (localDate !== null) {
        var todayDate = localDate.slice(0, 10);
        let d = todayDate.split("-");
        let dates = d[1] + '/' + d[2] + '/' + d[0];
        return dates;   
      }
    },
    stopPropagation(event) {
      event.stopPropagation();
    }
  },
  computed: {
    ...mapGetters(["FederalHolidays", "HolidayPagination", "role"])
  },
  watch: {
    FederalHolidays(obj) {
      this.holidays = obj;
    },
    HolidayPagination(num) {
      this.count_page = num;
    }
  },
  mounted() {
    if (this.$store.getters.FederalHolidays) {
      this.holidays = this.$store.getters.FederalHolidays;
    }
    if (this.$store.getters.HolidayPagination !== null) {
      this.count_page = this.$store.getters.HolidayPagination;
    }
    // this.sendSearchReq();
  }
};
</script>

<style scoped lang="scss">
.kits {
  margin: 20px 0 0 0;
}
.description-modal{
  text-align: start;
  position: absolute;
  top: 62px;
  z-index: 9990;
}
.kits-title {
  display: flex;
  justify-content: space-between;
  margin: 0 0 20px 0;
  padding: 0 30px;
}
.title {
  color: #b3b3b3;
  font-size: 12px;
  font-family: TTNormsMedium, sans-serif;
}
.title.name {
  min-width: 500px;
  width: 100%;
  max-width: 500px;
}
.kit-desc.name {
  min-width: 500px;
  width: 100%;
  max-width: 500px;
}
.title.year {
  min-width: 500px;
  width: 100%;
  max-width: 500px;
}
.kit-desc.year {
  min-width: 500px;
  width: 100%;
  max-width: 500px;
}
.kit-desc.name span,
.kit-desc.year span {
  width: 100%;
  max-width: 140px;
  overflow: hidden;
  display: inline-block;
}
.title.date {
  min-width: 160px;
  width: 100%;
  position: relative;
  cursor: pointer;
}
.title.date img {
  max-width: 7px;
  height: 14px;
  position: absolute;
  top: -3px;
  right: 5px;
}
.title.date .down {
  transform: rotate(180deg);
}
.kit-desc.date {
  min-width: 160px;
  width: 100%;
}
.kits-item {
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: center;
  padding: 25px 30px;
  background-color: #fff;
  margin: 10px 0;
  border-radius: 5px;
}
.kits-item:hover {
  background-color: #e0e9f4;
}
.kits-item:hover .remove-kit-btn {
  display: block;
}
.kit-desc {
  color: #58595b;
  font-size: 12px;
  font-family: TTNormsLight, sans-serif;
}
.status-line {
  width: 100%;
  max-width: 140px;
  height: 3px;
  background-color: rgba(0, 70, 173, 0.3);
  margin: 5px 0 0 0;
  position: relative;
}
.status-line-bg {
  position: absolute;
  width: 50%;
  content: "";
  left: 0;
  top: 0;
  height: 100%;
  background-color: #005eb8;
}
.pogination {
  margin: 20px 0 0 0;
}
.remove-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  padding: 0;
}
.remove-kit-btn {
  display: none;
  position: absolute;
  width: 20px;
  height: 20px;
  border: 1px solid #58595b;
  border-radius: 5px;
  right: 20px;
  cursor: pointer;
  &:before,
  &:after {
    content: "";
    display: block;
    position: absolute;
    height: 1px;
    width: 13px;
    background-color: #58595b;
    top: 50%;
    left: 50%;
    transform: translate(-50%) rotate(45deg);
  }
  &:after {
    transform: translate(-50%) rotate(-45deg);
  }
  &:hover {
    border-color: red;
    &:before,
    &:after {
      background-color: red;
    }
  }
}
@media print {
  .kits {
    display: none;
  }
}
.prob-count {
  text-align: right;
  color: #58595b;
  font-family: TTNormsLight, sans-serif;
  font-size: 13px;
  font-weight: bold;
}
.prob-count.custom {
  margin-bottom: 20px;
}
.kit-desc.nodata {
  width: 100%;
  overflow: hidden;
  display: inline-block;
  text-align: center;
}
</style>
